import {NgModule} from '@angular/core';
import {InsightsHelpComponent} from './insights-help.component';
import {ModalModule} from "ngx-bootstrap/modal";
import {BrowserModule} from "@angular/platform-browser";
import {InsightsHelpModalModule} from "../insights-help-modal/insights-help-modal.module";
import { ButtonModule } from '@xref/xref-lib';

@NgModule({
  declarations: [InsightsHelpComponent],
  imports: [
    BrowserModule,
    ModalModule,
    InsightsHelpModalModule,
    ButtonModule
  ],
  exports: [InsightsHelpComponent]
})
export class InsightsHelpModule { }
